/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-boolean-value */
import React, { useContext, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { UserDetailsContext } from "../../context/userDetails";
import Logo from "../../assets/logo-icon.svg";
import { toSetAndRemoveParams } from "../../utils/util";

function QRCode({ handleClose }) {
	const { mobileUrl, setMobileUrl } = useContext(UserDetailsContext);
   const {pathname} = useLocation()
	
	useEffect(() => {
		if (!pathname.includes("custom")) {
			setMobileUrl(toSetAndRemoveParams({}));
		}
	}, [pathname]);

	return (
		<div className="bg-[#fff]/80 backdrop-blur-sm flex items-center justify-center h-full">
			<div className="text-center shadow-lg rounded-lg bg-[#FCFCFC] relative max-w-[350px] mx-auto pt-[30px] pb-[35px] px-[50px] radius-[20px] border-0 border-transparent  text-[#25333A]">
				<div className="absolute left-[40px] z-[0] top-[45px] right-[40px] bottom-[110px] bg-[#fff] rounded-[20px]" />
				{handleClose && (
					<span
						className="absolute cursor-pointer right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-0 focus:ring-transparent focus:ring-offset-0 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
						onClick={handleClose}
					>
						<X size={16} />
					</span>
				)}

				<div className="relative z-[1]">
					<div className="flex items-center justify-center border-[#5A32F3] rounded-full w-[32px] h-[32px] mx-auto p-[5px] border mb-[20px]">
						<img src={Logo} alt="logo" />
					</div>
					<div className="mb-[22px] text-[15px] font-[500] ">Continue on Mobile</div>

					<QRCodeSVG value={mobileUrl || window.location.origin} className="mx-auto" size={140} />

					<div className="mt-[60px] text-center text-[12px] max-w-[240px] mx-auto leading-[1.2]">
						<p className="mb-[15px]">To create your Swan account, you&apos;ll need to use your phone.</p>
						<p>Scan this QR code to get started.</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default QRCode;
